import React from 'react';

import { InfoPageWrapper } from '../../shared/infoPageWrapper';
import MaxWidth from '../../shared/MaxWidth';
import PageHeader from '../../shared/PageHeader';
import * as S from '../press/Press.styles';
import { Plans, PricingProps, QuestionAnswers } from './';

export const PricingPageContent: React.FC<PricingProps> = props => {
  return (
    <InfoPageWrapper>
      <MaxWidth>
        <S.Content>
          <S.TextBox>
            <S.Caption>Subscribe</S.Caption>
            <S.Description>Get the full Brain.fm experience.</S.Description>
          </S.TextBox>
          <Plans  {...props} />
          <PageHeader title="Questions & Answers" />
          <QuestionAnswers />
        </S.Content>
      </MaxWidth>
    </InfoPageWrapper>
  );
};
